// @flow
import { Store } from '@homie/flux';
import Dispatcher from 'dispatcher';
import {
  SET_REPORT_FULL,
  SET_REPORT_PREVIEW
} from 'modules/external_tenant/api/action_types/OwnerReportActionTypes';

let _reportPreview = {};
let _reportFull = {};

class OwnerReportStore extends Store {
  constructor() {
    super();
    Dispatcher.register(this.reducer);
  }

  getReportPreview = () => {
    return _reportPreview;
  };

  getReportFull = () => {
    return _reportFull;
  };

  reducer = (action: any) => {
    switch (action.type) {
      case SET_REPORT_FULL:
        _reportFull = action.payload;
        break;
      case SET_REPORT_PREVIEW:
        _reportPreview = action.payload;
        break;
    }
    this.notify();
  };
}

export default new OwnerReportStore();
